// extracted by mini-css-extract-plugin
export default {"loader":"IntermittentDots_loader__aeiz1","load6":"IntermittentDots_load6__-OC0T","round":"IntermittentDots_round__Odxp5"};